export const vekaQualificationOptions = [
  { value: 'not_qualified', label: 'Не квалифицирована' },
  { value: 'missed', label: 'Недозвон' },
  { value: 'measure', label: 'Запись на замер' },
  { value: 'bad_city', label: 'Неверный город' },
  { value: 'other_company', label: 'Заказал у другой компании' },
  { value: 'sell', label: 'Продажа' },
  { value: 'consult', label: 'Консультация по конструкциям и стоимости' },
  { value: 'support', label: 'Ремонт и комплектующие' },
  { value: 'nq', label: 'Спам' },
]

export const vekaFinalQualificationOptions = [
  { value: 'missed', label: 'Недозвон' },
  { value: 'consult', label: 'Консультация' },
  { value: 'sell', label: 'Продажа' },
  { value: 'failed', label: 'Сделка не состоялась' },
]
